import { render, staticRenderFns } from "./config-subtitle-languages.vue?vue&type=template&id=0fbc8b46&scoped=true"
import script from "./config-subtitle-languages.vue?vue&type=script&lang=js"
export * from "./config-subtitle-languages.vue?vue&type=script&lang=js"
import style0 from "./config-subtitle-languages.vue?vue&type=style&index=0&id=0fbc8b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc8b46",
  null
  
)

export default component.exports